import React from 'react';
import { Card, CardBody, Spinner } from 'reactstrap';

function DetectionStatistics({ Camstatusdata, statsLoader, alertcount}) {
  // Step 1: Stats data
  const statsData = [
    {
      label: "Total Detections",
      value: Camstatusdata?.total_logs,
      color: "",
    },
    {
      label: "Recognized",
      value: (Camstatusdata?.total_logs || 0) - (Camstatusdata?.total_violations || 0),
      color: "",
    },
    {
      label: "Unknown",
      value: Camstatusdata?.total_violations,
      color: "#DC2626",
    },
    {
      label: "Blacklisted",
      value: Camstatusdata?.blacklisted,
      color: "#DC2626",
    },
    {
      label: "Total SOP Followed",
      value: Camstatusdata?.sop_followed,
      color: "#1D67AA",
    },
    {
      label: "Total SOP Un Followed",
      value: Camstatusdata?.sop_unfollowed,
      color: "#DC2626",
    },
  ];

  return (
    <Card className="pb-0">
      <CardBody className="pb-0">
        {/* Heading */}
        <h2 className="py-2" style={{ fontSize: "18px", fontWeight: "600", color: "#1D67AA" }}>
          Detection Statistics
        </h2>

        {/* Loader or Statistics */}
        {statsLoader ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
            <Spinner color="success" />
          </div>
        ) : (
          statsData.map((stat, index) => (
            <div className="d-flex justify-content-between align-items-center py-3" key={index}>
              <h2 style={{ fontSize: "14px", fontWeight: "400", color: "#4B5563" }}>
                {stat.label}
              </h2>
              <h5 style={{ fontSize: "20px", fontWeight: "700", color: stat.color || "#000" }}>
                {stat.value}
              </h5>
            </div>
          ))
        )}
      </CardBody>
    </Card>
  );
}

export default DetectionStatistics;
